/* eslint-disable arrow-body-style */
import http from './utils';
import { overviewOriginType } from '@/pages/opinion/types/performance';
import { mockPrefix, prefix } from './constants';
import axios from 'axios';
const CancelToken = axios.CancelToken;

export const getTrackTopicList: (
  payload: any,
) => Promise<overviewOriginType> | overviewOriginType = payload => {
  return http({
    url: `${prefix}/summary/track_topic`,
    method: 'post',
    data: payload,
  }) as Promise<overviewOriginType>;
};

export const getTierTopicList: (
  payload: any,
) => Promise<overviewOriginType> | overviewOriginType = payload => {
  return http({
    url: `${prefix}/summary/topic_list`,
    method: 'post',
    data: payload,
  }) as Promise<overviewOriginType>;
};

export const setTierTopicConfig: (
  payload: any,
) => Promise<overviewOriginType> | overviewOriginType = payload => {
  return http({
    url: `${prefix}/summary/set_user_topic_conf`,
    method: 'post',
    data: payload,
  }) as Promise<overviewOriginType>;
};

export const getHasTopicReport: (
  payload: any,
) => Promise<overviewOriginType> | overviewOriginType = payload => {
  return http({
    url: `${prefix}/summary/has_topic_report`,
    method: 'post',
    data: payload,
  }) as Promise<overviewOriginType>;
};

export const getTierTopicConfig: (
  payload: any,
) => Promise<overviewOriginType> | overviewOriginType = payload => {
  return http({
    url: `${prefix}/summary/get_user_topic_conf`,
    method: 'post',
    data: payload,
  }) as Promise<overviewOriginType>;
};

export const getTopicTimeline: (
  payload: any,
  cancelTokenFunc?: (cancel: any) => void,
) => Promise<overviewOriginType> | overviewOriginType = (
  payload,
  cancelTokenFunc = c => {},
) => {
  return http({
    url: `${prefix}/summary/topic_timeline`,
    method: 'post',
    data: payload,
    cancelToken: new CancelToken(cancelTokenFunc),
  }) as Promise<overviewOriginType>;
};

export const getTopicKeywords: (
  payload: any,
) => Promise<overviewOriginType> | overviewOriginType = payload => {
  return http({
    url: `${prefix}/summary/topic_keywords`,
    method: 'post',
    data: payload,
  }) as Promise<overviewOriginType>;
};

export const getBatchTopicKeywords: (
  payload: any,
) => Promise<overviewOriginType> | overviewOriginType = payload => {
  return http({
    url: `${prefix}/summary/batch_topic_keywords`,
    method: 'post',
    data: payload,
  }) as Promise<overviewOriginType>;
};

export const getBatchTopicTopicL1ToL2Stats: (
  payload: any,
) => Promise<overviewOriginType> | overviewOriginType = payload => {
  return http({
    url: `${prefix}/summary/topic_l1_to_l2_stats`,
    method: 'post',
    data: payload,
  }) as Promise<overviewOriginType>;
};

export const getWordCloud: (
  payload: any,
) => Promise<overviewOriginType> | overviewOriginType = payload => {
  return http({
    url: `${prefix}/summary/word_cloud`,
    method: 'post',
    data: payload,
  }) as Promise<overviewOriginType>;
};

export const getWordDownload: (
  payload: any,
) => Promise<overviewOriginType> | overviewOriginType = payload => {
  return http({
    url: `${prefix}/summary/word_download`,
    method: 'post',
    data: payload,
  }) as Promise<overviewOriginType>;
};

export const getWord: (
  payload: any,
) => Promise<overviewOriginType> | overviewOriginType = payload => {
  return http({
    url: `${prefix}/summary/word`,
    method: 'post',
    data: payload,
  }) as Promise<overviewOriginType>;
};

export const getWordCommentsSentiment: (
  payload: any,
) => Promise<overviewOriginType> | overviewOriginType = payload => {
  return http({
    url: `${prefix}/summary/word_comments_sentiment`,
    method: 'post',
    data: payload,
  }) as Promise<overviewOriginType>;
};

export const getSummaryTrackTopic: (
  payload: any,
) => Promise<overviewOriginType> | overviewOriginType = payload => {
  return http({
    url: `${prefix}/summary/track_l1_topic`,
    method: 'post',
    data: payload,
  }) as Promise<overviewOriginType>;
};

export const getSummaryHotEventList: (
  payload: any,
  cancelTokenFunc?: (c: any) => void,
) => Promise<any> | any = (payload, cancelTokenFunc = (c: any) => {}) => {
  return http({
    url: `${prefix}/summary/hot_event/list`,
    method: 'post',
    data: payload,
    cancelToken: new CancelToken(cancelTokenFunc),
  }) as Promise<overviewOriginType>;
};

// Hot Event V2 列表接口
export const getSummaryHotEventListV2 = (config: {
  data: any;
  cancelToken?: any;
  headers?: any;
}) => {
  return http({
    url: `${prefix}/summary/hot_event/list_v2`,
    method: 'post',
    ...config,
  });
};

// Hot Event Cluster 分类列表接口
export const getSummaryHotEventClusterCategories = (config: {
  data: any;
  cancelToken?: any;
  headers?: any;
}) => {
  return http({
    url: `${prefix}/summary/hot_event/cluster_categories`,
    method: 'post',
    ...config,
  });
};

export const getSummaryHotEventStatsComments: (
  payload: any,
) => Promise<overviewOriginType> | overviewOriginType = payload => {
  return http({
    url: `${prefix}/summary/hot_event/stats_comments`,
    method: 'post',
    data: payload,
  }) as Promise<overviewOriginType>;
};

export const getSummaryHotEventTimeLine: (
  payload: any,
) => Promise<overviewOriginType> = payload => {
  return http({
    url: `${prefix}/summary/hot_event/timeline`,
    method: 'post',
    data: payload,
  }) as Promise<overviewOriginType>;
};

/** Hot Event 趋势图批量接口 */
export const getSummaryHotEventTrendBatch = (config: {
  data: any;
  cancelToken?: any;
  headers?: any;
}) => {
  return http({
    url: `${prefix}/summary/hot_event/trend_batch`,
    method: 'post',
    ...config,
  });
};

export const getSummaryTopicReport: (
  payload: any,
) => Promise<overviewOriginType> | overviewOriginType = payload => {
  return http({
    url: `${prefix}/summary/topic_report`,
    method: 'post',
    data: payload,
  }) as Promise<overviewOriginType>;
};

export const getSummaryKeywordFilter: (
  payload: any,
) => Promise<overviewOriginType> | overviewOriginType = payload => {
  return http({
    url: `${prefix}/game/keyword_filter`,
    method: 'post',
    data: payload,
  }) as Promise<overviewOriginType>;
};

export const updateSummaryName: (
  payload: any,
) => Promise<overviewOriginType> | overviewOriginType = payload => {
  return http({
    url: `${prefix}/summary/update_summary_name`,
    method: 'post',
    data: payload,
  }) as Promise<overviewOriginType>;
};

export const summaryDownloadHotEventData: (
  payload: any,
  cancelCallback?: any,
) => Promise<any> | any = (payload, cancelCallback = () => {}) => {
  return http({
    url: `${prefix}/summary/hot_event/download`,
    method: 'post',
    data: payload,
    cancelToken: new axios.CancelToken(cancelCallback),
    errorHandler: true,
  }) as Promise<any>;
};

/**
 * 高级量化总结下钻页 — 获取事件列表
 * POST api/v1/opinion_pc/summary/advanced/event_list
 */
export const getEventDetailsData: (
  payload: any,
  cancelTokenFunc?: (c: any) => void,
) => Promise<any> | any = (payload, cancelTokenFunc = (c: any) => {}) => {
  return http({
    url: `${prefix}/summary/advanced/event_list`,
    method: 'post',
    data: payload,
    cancelToken: new CancelToken(cancelTokenFunc),
  }) as Promise<any>;
};

// Hot Event Avg Sentiment 情感分组列表接口
export const getSummaryHotEventAvgSentiments = (config: {
  data: any;
  cancelToken?: any;
  headers?: any;
}) => {
  return http({
    url: `${prefix}/summary/hot_event/avg_sentiments`,
    method: 'post',
    ...config,
  });
};
